export const confirmationCodesStatus = {
  1:"Created",
  3:"Claim / Expired"
}
